import {
  LandingTemplate,
  MappingLike,
  RouteLike,
} from "../types/api";
import {
  normPath,
  normSub,
} from "@/helpers/helpers.app";


// util для витягування макросів та публічних ендпоінтів
export const getTplCfg = (tpl: LandingTemplate | null | undefined) => {
  const rawCfg: any = (tpl as any)?.config ?? {};
  const cfg: any =
    typeof rawCfg === "string"
      ? (() => {
        try {
          return JSON.parse(rawCfg);
        } catch {
          return {};
        }
      })()
      : rawCfg;

  const parseArr = (v: any) => {
    if (typeof v === "string") {
      try {
        return JSON.parse(v) ?? [];
      } catch {
        return [];
      }
    }
    return Array.isArray(v) ? v : v ?? [];
  };

  const macros = parseArr(cfg.macros ?? (tpl as any)?.macros);
  const publicEndpoints = parseArr(cfg.publicEndpoints);

  return {
    ...cfg,
    macros,
    publicEndpoints,
  };
};

// util для перевірки кофліктів шляхів
export const findApiVsStaticConflicts = (
  routes: RouteLike[],
  mappings: MappingLike[],
) => {
  const conflicts: Array<{ sub: string; path: string; api?: string }> = [];

  const routeKeys = new Set(
    (routes || [])
      .filter((r) => r && r.basePath)
      .map((r) => `${normSub(r.subdomain)}::${normPath(r.basePath)}`),
  );

  (mappings || [])
    .filter((m) => m && m.path && m.enabled !== false)
    .forEach((m) => {
      const key = `${normSub(m.subdomain)}::${normPath(m.path)}`;
      if (routeKeys.has(key)) {
        conflicts.push({
          sub: normSub(m.subdomain),
          path: normPath(m.path),
          api: m.handler,
        });
      }
    });

  return conflicts;
};
